import React, { useEffect, useState } from 'react'
import Header from '../../../component/Produzioni/Header'
import DashboardCard from '../../../component/Produzioni/DashboardCard';
import TableInputPigiatura from '../../../component/Produzioni/TableInputPigiatura';
import TrattamentiFrom from '../../../component/Produzioni/TrattamentiFrom';
import { useDispatch, useSelector } from 'react-redux';
import { resetFormSubmit, storeFormData } from '../../../features/produzioniFormData/produzioniFormDataSlice';
import produzioniFormAPI from '../../../services/produzioniFormApi';

const Pigiaturaediraspatura = ({option, activeStep, setActiveStep }) => {
    const dispatch = useDispatch();
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const submitForm = useSelector((state) => state.produzioniForm.submitForm);

    const [tableData, setTableData] = useState([
        { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, date_of_pigiatura: null, qty_uva_lavorata: "", qty_raspi_rimossi: "", percent_raspi_rimossi: "", temp_mosto: "", ph_del_mosto: "" },
    ]);

    const [treatment, setTreatment] = useState([
        { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, pro_treatment_id: "", tratt_date: null, pro_utilizzato: "", pro_qty: "", mod_di_applicazione: "", operatore_id: "", sicurezza: "" }
    ]);

    tableData.map((item)=> {
      if(item.qty_uva_lavorata > 0){
        item.percent_raspi_rimossi = ((item.qty_raspi_rimossi/item.qty_uva_lavorata)*100).toFixed(2);
      }else{
        item.percent_raspi_rimossi = 0
      }
    })


    const data = {
        id: 1,
        title: "Pigiatura e diraspatura",
        description:
            "Regola il processo per ottenere un mosto di qualità, eliminando impurità e raspi in eccesso.",
        buttonText: "Completa fase",
    };

    const temperatureCompliance = tableData.reduce((acc, item) => acc + Number(item.qty_uva_lavorata), 0);
    const totalCollected = tableData.reduce((acc, item) => acc + Number(item.qty_raspi_rimossi), 0);
    const totalMosto = tableData.reduce((acc, item) => acc + Number(item.ph_del_mosto), 0)/ tableData.length;
    const dummyData = {

        temperatureCompliance: temperatureCompliance + " Kg",
        totalCollected: totalCollected + " Kg",
        discardedGrapes:  temperatureCompliance > 0 
        ? ((totalCollected / temperatureCompliance) * 100).toFixed(2) + "%" 
        : "0%",
        mosto: totalMosto,
        tasks: [
            "Separazione dei raspi",
            "Pigiatura degli acini",
            "Monitoraggio dei parametri del mosto",
        ],
    };

    const infoFields = [
        { label: "Totale UVA lavorata", key: dummyData.temperatureCompliance, },
        { label: "Q.ta totale Raspi rimossi", key: dummyData.totalCollected },
        { label: "% totale Raspi rimossi", key: dummyData.discardedGrapes, showIcon: true },
        { label: "mosto", key: dummyData.mosto, showIcon: true },
    ];

    const fetchDataForUpdate = async () => {
        try {
          const payload = {
            company_id: localStorage.getItem('company_id'),
            step: activeStep,
            prod_id: singleProduzioneID,
          };
    
          const response = await produzioniFormAPI.getSingleStepFormData(payload);
          console.log(response, "response racolta")
          if (response?.data.data.pigiatura?.length) {
            const existingTable = response.data.data.pigiatura;
            setTableData(existingTable);
          }
          if (response?.data.data.production_step_treatment?.length) {
            const existingTreatment = response.data.data.production_step_treatment;
            setTreatment(existingTreatment);
          }
        } catch (error) {
          console.error("Error fetching single step form data:", error);
        }
      };
      
      useEffect(() => {
          fetchDataForUpdate();
  
      }, []);
    
    const onSubmit = async (tableData, treatment) => {
        const data = {
            step: activeStep,
            forms: {
                pigiatura: tableData,
                production_step_treatment: treatment
            }
        }
        console.log("Submitted data:", data);
        try {
              await produzioniFormAPI.updateStepFormData(singleProduzioneID, data);
    
            setActiveStep((prev) => prev + 1);
          } catch (error) {
            fetchDataForUpdate();
            console.error('Error submitting form data:', error);
          }
    };

    useEffect(() => {
        if (submitForm) {
            onSubmit(tableData, treatment);
            dispatch(resetFormSubmit());
        }
    }, [submitForm, dispatch]);

    return (
        <>
            <Header data={data} setActiveStep={setActiveStep} activeStep={activeStep} />
            <DashboardCard dummyData={dummyData} infoFields={infoFields} />
            <TableInputPigiatura 
            option={option} 
            rows={tableData}
                setRows={setTableData}
                activeStep={activeStep}
                />
            <TrattamentiFrom 
            option={option}
            rows={treatment}
                setRows={setTreatment}
                activeStep={activeStep}
                 />
        </>
    )
}

export default Pigiaturaediraspatura